"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Todo = void 0;
const date_fns_1 = require("date-fns");
const api_client_1 = __importDefault(require("./api-client"));
const confirm_1 = require("./confirm");
class Todo {
    constructor() {
        // convert date
        this.todoTaskDates = document.querySelectorAll('[data-convertToDate]');
        for (let i = 0; i < this.todoTaskDates.length; i++) {
            const str = this.todoTaskDates[i].getAttribute("data-convertToDate");
            if (str) {
                this.todoTaskDates[i].textContent = (0, date_fns_1.format)(new Date(str), 'dd-LL-yyyy');
            }
            else {
                this.todoTaskDates[i].textContent = "-";
            }
        }
        // add update button events
        this.updateButtons = document.querySelectorAll('[data-update]');
        for (let i = 0; i < this.updateButtons.length; i++) {
            this.updateButtons[i].addEventListener('click', (event) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const { currentTarget } = event;
                (_a = this.confirmElement) === null || _a === void 0 ? void 0 : _a.classList.add("show");
                const result = yield (0, confirm_1.confirm)();
                (_b = this.confirmElement) === null || _b === void 0 ? void 0 : _b.classList.remove("show");
                if (currentTarget && result) {
                    const id = currentTarget.getAttribute("data-update");
                    yield Todo.update(id);
                }
            }));
        }
        this.confirmElement = document.querySelector('.confirm');
        // add delete button event
        this.deleteButton = document.querySelector('[data-delete]');
        if (this.deleteButton) {
            this.deleteButton.addEventListener('click', (event) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const { currentTarget } = event;
                (_a = this.confirmElement) === null || _a === void 0 ? void 0 : _a.classList.add("show");
                const result = yield (0, confirm_1.confirm)();
                (_b = this.confirmElement) === null || _b === void 0 ? void 0 : _b.classList.remove("show");
                if (currentTarget && result) {
                    const id = currentTarget.getAttribute("data-delete");
                    yield Todo.remove(id);
                }
            }));
        }
    }
    static init() {
        new this();
    }
    static remove(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield api_client_1.default.delete(`/api/todo/${id}`);
                window.location.replace('/');
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    static update(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield api_client_1.default.put(`/api/todo/${id}`);
                window.location.replace('/');
            }
            catch (error) {
                console.log(error);
            }
        });
    }
}
exports.Todo = Todo;
